<div class="kl-global-loader" [class.kl-global-loader--visible]="visible()">
  <div class="kl-global-loader__backdrop"></div>
  <div class="kl-global-loader__content" role="status" aria-live="polite" aria-labelledby="kl-global-loader-label">
    <div class="kl-global-loader__panel">
      <img class="kl-global-loader__favicon" src="/favicon.png" alt="" aria-hidden="true" />
      <p id="kl-global-loader-label" class="kl-global-loader__label">{{ 'loading' | translate }}</p>
    </div>
  </div>
</div>
